import { render, staticRenderFns } from "./ArchivedCauselist.vue?vue&type=template&id=2084441e"
import script from "./ArchivedCauselist.vue?vue&type=script&lang=js"
export * from "./ArchivedCauselist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports